export const groupDictionary = {
  Temáticas: "Temas",
  "Año de producción": "Years",
  País: "Pais",
  // Idioma: "Idiomas",
  Secciones: "Secciones",
  "Ediciones AP": "EAP",
  "Ediciones Gira": "EGIRA",
  Generación: "Generaciones",
  "Tipo de publicación": "Tipo",
};
